import Path from "../router/path";
import React from 'react';
import apiUrl from "./apiUrl";
import { joinUrl } from "@utils/";
import moment from "moment";

const GLOBAL_DOMAIN = 'https://portal-resource-global.j-make.cn/mrc/';

console.log("current environment:", process.env.ENV_CONFIG);//prod_dev
export default {
    // 服务器api域名
    BASE_API: process.env.BASE_API,
    // 3a授权服务器api域名
    CLOUD_API: process.env.CLOUD_AAA_API,
    // 上传接口
    UPLOAD_IMG_API: joinUrl(process.env.BASE_API, apiUrl.COMMON.UPLOAD_IMG),
    // 播放器脚本
    PLAYER: process.env.ENV_CONFIG === 'prod' ? `${GLOBAL_DOMAIN}mrc-player.min.js` : `${GLOBAL_DOMAIN}mrc-player-test.min.js`,
    SPEAK_WSS_API: 'wss://mrs-a.j-make.com.cn:12002',
    // 不获取用户信息页面白名单
    DO_NOT_GET_USER_INFO_WITH_LIST: [
        Path.LOGIN,
    ],
    // 默认标签code值
    DEFAULT_TAG_CODE: 'JMK_DEFAULT',
    // 导播台BizCode
    CASTER_CODE: "ljsy@a4c860b5-7cc5-4e47-900c-fdb9106b62cb",
    // CASTER_ID: "a8dad4d5-2c61-4e86-8a8a-6a65f73008eb",
    // 服务器错误状态
    HTTP_CODE: {
        SUCCESS: 2000, // 成功
        NO_PERMISSION: 4001, // 无权访问
        NEED_LOGIN: 4002, // 登录已过期请重新登录
        NEED_AUTH: 4005, // 授权已过期
    },
    // 验证手机号
    VALID_MOBILE: /^1[345789]\d{9}$/,
    // 事件类型
    EVENT: {
        EVENT_WINDOW_HASH_CHANGE: 'EVENT_WINDOW_HASH_CHANGE', // 监听url hash变化
        SIDEBAR_PATH_CHANGE: 'SIDEBAR_PATH_CHANGE', // 侧边菜单栏监听路径变化
    },

    // 7天免输入账号密码白名单
    LOGIN_WHITE_NAME_LIST: [
        '13086667075',
        '18602280013',
        'zhangguangpu'
    ],
    // 正则验证
    VALID: {
        // 验证密码，必须有一个大写字母and必须有一个小写字母and必须有一个数字and必须大于或等于8位
        PASSWORD: /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]))[A-Za-z0-9!@#$].{7,20}$/,
        // 验证密码 必须有一个大写字母and必须有一个小写字母and必须有一个特殊字符and必须大于或等于12位
        VALID_PASSWORD: /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[`~!@#$%^&*()_\-+=<>?:"|,.\/;'\\·~！@#￥%……&*（）——\-+=|《》？：“”、；‘'，。、]))[A-Za-z0-9`~!@#$%^&*()_\-+=<>?:"|,.\/;'\\·~！@#￥%……&*（）——\-+=|《》？：“”、；‘'，。、].{11,20}$/,
        // 判断用户名的email格式
        USERNAME_EMAIL: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // 判断直播地址格式
        LIVE_URL: /^(rtmp||srt):\/\/.+$/,
        // 不超过小数点两位
        POINT_TWO: /^\d+\.?\d{0,2}$/,
				// 最大不超过100，且小数点不超过四位
        POINT_FOUR: /^100$|^(\d|[0-9]\d)(\.\d{0,4})*$/,
        // ip格式
        IP: /^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])$/,
    },

    // 表格操作栏title
    TABLE_BTN_TITLE: '操作',
    TABLE_BTN_TYPE: 'modal',
    // 表格分页配置
    TABLE_PAGINATION: { // 分页配置
        position: 'bottom',
        size: "small",
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['2', '10', '50', '100', "400"],
        total: 0,
        showTotal: total => {
            return `共 ${total} 条`;
        },
    },
    // 表格展开行配置
    TABLE_EXPANDABLE: {
        indentSize: 50,
    },

    // 默认备注
    REMARK: {
        OFF_SHILF: '您的作品现已下架，主要因：xxxxxx，若有疑问，可点击下方用户反馈留言，感谢您的关注',
        ACCOUNT_BANED: '您的账号已被核实禁用，您将不能分享作品到K歌秀场。主要因：xxxxxx，若有疑问，可点击下方反馈留言，感谢您的关注',
        ACCOUNT_ON: '您的账号已启用，您可以分享作品到K歌秀场。',
    },

    LEIKE_OPTIONS: [
        { value: 1, label: '雷客' },
        { value: 2, label: '非雷客' },
    ],

    SONG_ALBUM: 1,
    SONG_ALBUM_GROUP: 2,

    //1为图片，2为文字，3为epg选择，4为load选择

    TYPE_I18N_KEY_IMG: 1,

    TYPE_I18N_KEY_TXT: 2,

    TYPE_I18N_KEY_EPG: 3,

    TYPE_I18N_KEY_LOAD: 4,

    // antd中时间格式化方法
    FORMAT_MAP: {
        'date-picker': value => value.format('YYYY-MM-DD'),
        'date-time-picker': value => value.format('YYYY-MM-DD HH:mm:ss'),
        'month-picker': value => value.format('YYYY-MM'),
        'range-picker': value => [value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD')],
        'range-time-picker': value => [
            value[0].format('YYYY-MM-DD HH:mm:ss'),
            value[1].format('YYYY-MM-DD HH:mm:ss'),
        ],
        'time-picker': value => value.format('HH:mm:ss'),
    },
    dataRangerOption: {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近15天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }]
    },
    IS_ENABLED_TRUE: 1,
    IS_ENABLED_FALSE: 2,

    DATE_RANGE_LIST: {
        ["今天"]: [moment().startOf('day'), moment().endOf('day')],
        ["昨天"]: [moment().startOf('day').add(-1, 'day'), moment().endOf('day').add(-1, 'day')],
        ["本周"]: [moment().add(-1, 'day').startOf("week").add(1, 'day'), moment().add(-1, 'day').endOf("week").add(1, 'day')],
        ["本月"]: [moment().startOf('month'), moment().endOf('month')],
        ["今年"]: [moment().startOf('year'), moment().endOf('year')],
    },
    ACTIVE_TYPE: [
        { label: '未中奖', value: 0 },
        { label: '会员天数', value: 1 },
        { label: '实物奖品', value: 2 },
        { label: '会员优惠券', value: 3 },
        { label: '有赞优惠券(通用)', value: 4 },
        { label: '有赞优惠券(指定)', value: 5 },
    ],

    /**
    * 数据权限范围
    * 1.全部数据权限 2本部门数据权限 3本部门及以下部门数据权限
    */
    DATE_SCOPES: [
        { label: '全部数据权限', value: 1 },
        { label: '本部门数据权限', value: 2 },
        { label: '本部门及以下部门数据权限', value: 3 },
    ],
    ACTIVITY_TYPES: [
        // { value: 0, label: "送VIP活动" },
        // { value: 1, label: "大转盘" },
        { value: 2, label: "每天歌曲限免" },
        // { value: 3, label: "设备首单折扣" },
        { value: 5, label: "促活活动" },
        { value: 6, label: "邀请好友活动" },
        { value: 7, label: "礼品赠送活动" },
    ],
    COUNT_TYPES: [
        { value: 1, label: "按次" },
        { value: 2, label: "按首" }
    ],
    IMG_TYPES: [
        { label: '轮播', value: 'swipe' },
        { label: '单图', value: 'img' },
    ],

    /**
     * 全局重要位置,重要组件的z-index值:
     *  antd原生modal弹窗: 1000
     *  下拉: 1006
     *  头部: 1009
     *  antd原生消息提示(message): 1010 现在设置为1015 (注意遮罩比它小1 1014)
     *  Popconfirm(按钮小确认提示): 1020
     *  */
    MAIN_Z_INDEX: {
        LAYOUT_HEADER: 1009,
        SELECT_POP: 1006,
        POP_CONFIRM: 1020,
        MODAL: 1015,
    },

    // 腾讯地图
    AMAP_CONFIG: {
        KEY: 'OVHBZ-A6EKZ-Q6GXQ-TXYIK-ZV2NS-UPFPS',
        SRC: 'https://map.qq.com/api/gljs?v=1.exp&key=OVHBZ-A6EKZ-Q6GXQ-TXYIK-ZV2NS-UPFPS&libraries=tools'
    },
};
